export const downloadUrl = (fileUrl: string, name: string): void => {
  const downloadLink = document.createElement('a');
  downloadLink.href = fileUrl;
  downloadLink.download = name;
  downloadLink.click();
};

export const downloadJson = (json: any, name: string): void => {
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(json, null, 4))}`;
  downloadUrl(dataStr, name);
};
